import React, { useMemo } from 'react';
import {ReportRounded} from "@mui/icons-material";

export default function useHotmathsIcon(iconName) {
    return useMemo(() => {
        if (!iconName || typeof iconName !== 'string') {
            console.error('useHotmathsIcon: `iconName` is required and must be a string.');
            return (
                <div style={{height: 50, width: 50}}></div>
            );
        }

        return (
            <div className="ch-header-mobile-icon" data-icon={`${iconName}-icon`}>
                <svg width="50px" height="50px" viewBox="0 0 128 128">
                    <use href={`#${iconName}-icon`} />
                </svg>
            </div>
        );
    }, [iconName]);
}
